"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMode = getMode;
exports.getProd = getProd;
exports.isMerchant = exports.isFigure = exports.isEnvProd = void 0;
exports.setProd = setProd;
var isEnvProd = typeof window !== 'undefined' && window.location && window.location.hostname.indexOf('figure.com') > -1 && window.location.hostname.indexOf('test') < 0; // use environment if present  (injected from jenkins build or the parent project - frontend-onboarding) , else the old way

exports.isEnvProd = isEnvProd;
var isProd = process.env.REACT_APP_ENV !== undefined ? process.env.REACT_APP_ENV === 'production' : isEnvProd; // allow override

function setProd() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  isProd = value;
}

function getProd() {
  return isProd;
}

var merchantProviders = ['petersendean', 'ifunding', 'pella'];
var whitelabels = ['caliber', 'homepoint'];

function getMode() {
  if (typeof window !== 'undefined' && window.location) {
    var hostname = window.location.hostname;

    if ([].concat(merchantProviders, whitelabels).some(function (org) {
      return hostname.indexOf(org) > -1;
    })) {
      return [].concat(merchantProviders, whitelabels).find(function (org) {
        return hostname.indexOf(org) > -1;
      });
    }
  }

  return 'figure';
}

var isFigure = getMode() === 'figure';
exports.isFigure = isFigure;
var isMerchant = merchantProviders.includes(getMode());
exports.isMerchant = isMerchant;